import { createGlobalStyle } from 'styled-components';
import { fonts } from '@izettle/otto';

const getFontFile = file => format => `url(${file}.${format})`;
const getFontFace = _ref => {
  let {
    name,
    formats
  } = _ref;
  return _ref2 => {
    let {
      file,
      weight
    } = _ref2;
    return `
  @font-face {
    font-family: ${name};
    font-weight: ${weight};
    src: ${formats.map(getFontFile(file)).join(", ")};
  }
`;
  };
};
const getFontFamily = _ref3 => {
  let {
    fonts: fontVersions,
    ...fontProps
  } = _ref3;
  return Object.values(fontVersions).map(getFontFace(fontProps)).join("");
};
const fontFamiliesMixin = Object.values(fonts).map(getFontFamily).join("");

/**
 * 1. Applies `box-sizing: border-box` to all elements.
 * 2. Declares @font-face for Zen and Dingbatz.
 * 3. Sets Zen as the default font-family for all elements.
 */
const GlobalOttoStyles = createGlobalStyle`
  ${fontFamiliesMixin}

  * {
    font-family: ${fonts.zen.name};
    box-sizing: border-box;
  }
`;

export { GlobalOttoStyles };
//# sourceMappingURL=global-styles.js.map
